<template>
  <div class="full-height">
    <div class="nav">
       <!-- <Breadcrumb>
      <BreadcrumbItem :to="`/alliance/hbue/teaching/student?schoolId=${$route.query.schoolId}`">教学中心</BreadcrumbItem>
      <BreadcrumbItem @click="$router.go(-1)">我的作业</BreadcrumbItem>
      <BreadcrumbItem to>量化投资实验课-作业详情</BreadcrumbItem>
    </Breadcrumb> -->
    <!-- 按钮 -->
    <div class="action fr">
      <Button @click="$router.go(-1)">返回</Button>
    </div>
    </div>
    <notebook-view :id="codeFileId" me></notebook-view>
    <!-- <detail-page v-for="item in ids" :key="item" :id="item" v-show="activeId===item"></detail-page> -->
  </div>
</template>
<script>
import notebookView from "@/components/notebook/notebook-view.vue";
export default {
  name: 'researchDocument',
    data() {
    return {
      // 3678
       codeFileId: this.$route.query.strategyId,
    }
    },
  components: {
    notebookView,
  }
};
</script>
<style lang="less" scoped>
.full-height{
  height: 700px;
  .nav{
    width: 1200px;
    margin: 0 auto;
  }
  .action{
    margin-top: 14px;
  }
}
</style>